import { render } from "./fake_receipt.vue?vue&type=template&id=59770eac&scoped=true"
import script from "./fake_receipt.vue?vue&type=script&lang=js"
export * from "./fake_receipt.vue?vue&type=script&lang=js"

import "./fake_receipt.vue?vue&type=style&index=0&id=59770eac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59770eac"]])

export default __exports__